import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { clearServerIps } from '../api/serverIpSlice';

export const RouteChangeWatcher  = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearServerIps());
  }, [location.pathname, dispatch]);

  return null;
};